import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import {GrowlModule} from 'primeng/growl';
import {Message} from 'primeng/components/common/api';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public txtusername: string;
  public txtpassword: string;
  public showErrMsg = false;
  public welcomeMsg2: string = "";
  public showLoadMsg = false;
  public msgs: Message[] = [];

  constructor(private loginService:LoginService,private router: Router) { }

  ngOnInit() {
  }

  Login(){
    this.showLoadMsg = true;
    let login = null;
    this.showErrMsg = false;
    this.loginService.validateADLogin(this.txtusername,this.txtpassword)
    .subscribe(data=>{
      if(data!=null)
      {
          sessionStorage.setItem("LoginSession", data.toString());
          sessionStorage.setItem("UserName", this.txtusername.toString());

          if(data==true)
          {
            this.showLoadMsg = false;
            
            this.router.navigateByUrl('/selection');
          }
          else
          {
            this.showLoadMsg = false;
            //this.showErrMsg = true;
           //this.welcomeMsg2 = "Invalid UserName or Password. Please try again."
            this.msgs = [];
            this.msgs.push({severity:'error', summary:'Error', detail:'Invalid UserName or Password. Please try again.'});
          }
      }

    }, error => {
      console.log("Error", error);
      
  });
  }

}
